export default class WelcomePageHighlightBlock {
    public id: number;
    public highlightTitle: string;
    public highlightBody: string;
    public highlightImage: string;
    public highlightUrlText: string;
    public highlightUrl: string;
    public highlightUrlTarget: string;
    public isMainHighlight: boolean;
    public additionalHighlightBoxCssClass: string;
  
    constructor() {
      this.id = -1;
      this.highlightTitle = "";
      this.highlightBody = "";
      this.highlightImage = "";
      this.highlightUrlText = "";
      this.highlightUrl = "";
      this.isMainHighlight = false;
      this.additionalHighlightBoxCssClass = "";
      this.highlightUrlTarget = "";
    }
  }


// WEBPACK FOOTER //
// ./src/api/welcomePageHighlightBlockEntity.ts